import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Reveal, RevealGroup } from '../ui/Reveal';
import { LeaderPortrait } from './LeaderPortrait';
import { LEADERS, TEAM_INTRO } from './teamData';
import './team.css';

// Compact "Meet the leadership" strip, reused on the homepage and About page.
export const LeadershipPreview = ({ eyebrow = 'Leadership', title = 'The people behind CHIRE', testid = 'leadership-preview' }) => {
  const navigate = useNavigate();
  const open = (id) => navigate(id ? `/about/team#${id}` : '/about/team');

  return (
    <section className="team-preview" data-testid={testid}>
      <div className="team-preview-inner">
        <Reveal>
          <div className="team-preview-head">
            <div>
              <div className="team-eyebrow">{eyebrow}</div>
              <h2 className="team-preview-title">{title}</h2>
              <p className="team-preview-sub">{TEAM_INTRO.tagline}</p>
            </div>
            <button className="team-btn team-btn-outline" onClick={() => open()} data-testid={`${testid}-all-btn`}>
              Meet the leadership team
              <span aria-hidden="true" className="team-btn-arrow">→</span>
            </button>
          </div>
        </Reveal>
        <RevealGroup className="team-preview-grid" stagger={0.1}>
          {LEADERS.map((l) => (
            <Reveal key={l.id}>
              <button className="team-preview-card" onClick={() => open(l.id)} data-testid={`${testid}-card-${l.id}`}>
                <LeaderPortrait leader={l} className="team-preview-photo" />
                <span className="team-preview-body">
                  <span className="team-preview-role">{l.role} · {l.focus}</span>
                  <span className="team-preview-name">{l.name}</span>
                  <span className="team-preview-headline">{l.headline}</span>
                  <span className="team-preview-link">Read profile <span aria-hidden="true">→</span></span>
                </span>
              </button>
            </Reveal>
          ))}
        </RevealGroup>
      </div>
    </section>
  );
};

export default LeadershipPreview;
